import { RedoButton } from "@redotech/arbiter/buttons/redo-button";
import { RedoCollapseSubsection } from "@redotech/arbiter/collapse/redo-collapse-section";
import { Flex } from "@redotech/arbiter/flex";
import { RedoTextareaInputField } from "@redotech/arbiter/input/redo-textarea-input-field";
import { Text } from "@redotech/arbiter/text";
import UploadCloudIcon from "@redotech/redo-icons/upload-cloud-02.svg";
import { memo } from "react";
import { useGorgiasKnowledgeImport } from "../../gorgias-import/use-gorgias-import";

export const GorgiasKnowledgeTab = memo(function GorgiasKnowledgeTab({
  teamId,
}: {
  teamId: string | undefined;
}) {
  const { jsonText, setJsonText, loading, handleImport } =
    useGorgiasKnowledgeImport({ teamId });

  return (
    <Flex dir="column" gap="md">
      <Text fontSize="sm" textColor="secondary">
        Paste the JSON response from the Gorgias Knowledge Base / Help Center
        articles API endpoint. Articles will be imported as AI knowledge entries
        that can be used by the support agent.
      </Text>
      <RedoCollapseSubsection title="Instructions">
        <Flex dir="column" gap="sm" pl="lg">
          <Text fontSize="sm" textColor="secondary">
            To add this import:
          </Text>
          <Text fontSize="sm" textColor="secondary">
            <li>
              • Go to Gorgias and open your developer tools (right click,
              inspect)
            </li>
            <li>• Go to the network tab</li>
            <li>• Search for "articles?"</li>
            <li>• Go to the knowledge base / help center section in Gorgias</li>
            <li>• Copy the response and paste it into this input</li>
          </Text>
        </Flex>
      </RedoCollapseSubsection>
      <RedoTextareaInputField
        disabled={loading}
        label="Gorgias knowledge JSON"
        placeholder="Paste Gorgias knowledge base articles JSON here"
        setValue={setJsonText}
        value={jsonText}
      />
      <div>
        <RedoButton
          disabled={!jsonText.trim() || loading}
          hierarchy="primary"
          IconLeading={UploadCloudIcon}
          onClick={handleImport}
          pending={loading}
          size="md"
          text="Import knowledge"
          theme="normal"
        />
      </div>
    </Flex>
  );
});
